import { Fragment, memo } from "react";
import { Button, ButtonTypes, ConfirmModal, Input } from "@clintonelec/react-storybook";
import CertificateSelectModal from "Components/ConfigLayout/Network/SecuritySettings/CertificateSelectModal";
import "Components/ConfigLayout/Network/SecuritySettings/CertificateField/CertificateField.less";
import CertificateInfoModal from "Components/ConfigLayout/Network/SecuritySettings/CertificateInfoModal";
import { CertificateType, type SecurityCertificate } from "Interfaces";

type CertificateProps = {
	ieeeEnabled?: boolean;
	certificate: SecurityCertificate;
	handleCertUpdate?: (value: SecurityCertificate) => void;
};

const CertificateField = (props: CertificateProps) => {
	const { ieeeEnabled, certificate, handleCertUpdate: updateCertificate } = props;

	const handleDeleteClick = () => {
		updateCertificate?.({
			type: certificate.type,
			name: "",
			issuer: undefined,
			subject: undefined,
			validEnd: undefined,
			validStart: undefined
		});
	};

	let buttonContent = (
		<Fragment>
			<CertificateSelectModal
				ieeeEnabled={ ieeeEnabled }
				certificate={ certificate }
				handleCertUpdate={ updateCertificate }
			/>
			<ConfirmModal
				title={ `Delete ${ certificate.type }?` }
				modalContent="Deleting a certificate may result in loss of network connectivity."
				okButton={ { text: "Confirm", type: ButtonTypes.TERTIARY, onClick: handleDeleteClick } }
				cancelButton={ { text: "Cancel", type: ButtonTypes.DANGER } }
			>
				<Button
					className="cert-button"
					disabled={ !certificate.name || !ieeeEnabled }
					htmlType="button"
					type={ ButtonTypes.TERTIARY }
				>
					Delete
				</Button>
			</ConfirmModal>
		</Fragment>
	);

	if (certificate.type !== CertificateType.KEY && certificate.type !== CertificateType.DCV_HTTP) {
		buttonContent = (
			<Fragment>
				{ buttonContent }
				<CertificateInfoModal certificate={ certificate } ieeeEnabled={ ieeeEnabled } />
			</Fragment>
		);
	}

	return (
		<div className="form-row">
			<span>{ certificate.type }</span>
			<div className="form-switch-wrapper">
				<Input
					disabled
					name="ieeeId"
					placeholder={ certificate.name || "No Certificate." }
					value={ certificate.name }
					wrapClassName="cert-wrapper"
				/>
				{ buttonContent }
			</div>
		</div>
	);
};

export default memo(CertificateField);
